import { Button, Card, Image, Modal, Text, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import QueryString from "qs";
import toast from "react-hot-toast";
import useSWR from "swr";
import Empty from "@/components/placeholders/Empty";

export default function ItemSelectModal({ companyId, form }) {
  const [opened, { open, close }] = useDisclosure();

  const params = QueryString.stringify({
    filters: {
      company: companyId,
    },
    populate: "image",
    sort: ["createdAt:desc"],
  });

  const { data, isLoading } = useSWR(opened ? ["/items", params] : null);

  function handleSelect(item) {
    form.setValues({
      productItem: item?.image?.data,
    });
    toast.success("상차품이 선택되었습니다");
    close();
  }

  return (
    <>
      <Button fullWidth variant="default" onClick={open}>
        등록된 상차품 선택
      </Button>

      <Modal opened={opened} onClose={close} title="등록된 상차품 선택">
        {!isLoading && data?.data?.length === 0 && <Empty title="등록된 상차품이 없습니다" />}
        {data?.data?.map((row) => {
          const item = row?.attributes || {};
          return (
            <Card
              key={row.id}
              sx={{ cursor: "pointer" }}
              onClick={() => handleSelect(item)}
              mb="sm"
            >
              <Card.Section withBorder>
                <Image
                  // radius="md"
                  src={item?.image?.data?.attributes?.url}
                  height={200}
                  withPlaceholder
                  // sx={{ border: "1px solid gray" }}
                />
              </Card.Section>
              <Card.Section p="xs">
                <Title order={4}>{item?.name}</Title>
                <Text size="sm" color="dimmed">
                  {item?.description}
                </Text>
              </Card.Section>
            </Card>
          );
        })}
      </Modal>
    </>
  );
}
